import { render, staticRenderFns } from "./BnpoSummary.vue?vue&type=template&id=10953388&"
import script from "./BnpoSummary.vue?vue&type=script&lang=js&"
export * from "./BnpoSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports